var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthenticationHideInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "#E9E9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5127_27320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9497 26.9497C25.5252 28.0355 23.7906 28.6371 21.9997 28.6663C16.1663 28.6663 12.833 21.9997 12.833 21.9997C13.8696 20.0679 15.3073 18.3802 17.0497 17.0497M20.2497 15.533C20.8233 15.3987 21.4106 15.3316 21.9997 15.333C27.833 15.333 31.1663 21.9997 31.1663 21.9997C30.6605 22.946 30.0572 23.837 29.3663 24.658M23.7663 23.7663C23.5375 24.012 23.2615 24.209 22.9548 24.3456C22.6481 24.4822 22.3171 24.5557 21.9814 24.5616C21.6457 24.5676 21.3123 24.5058 21.001 24.3801C20.6897 24.2543 20.4069 24.0672 20.1695 23.8298C19.9321 23.5924 19.745 23.3096 19.6193 22.9983C19.4935 22.687 19.4318 22.3536 19.4377 22.0179C19.4436 21.6823 19.5171 21.3512 19.6537 21.0445C19.7904 20.7379 19.9874 20.4619 20.233 20.233M12.833 12.833L31.1663 31.1663",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5127_27320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationHideInfo);
export default __webpack_public_path__ + "static/media/authentication_hide_info.94da1b2d4b1d98a31ded16123996dc12.svg";
export { ForwardRef as ReactComponent };